import { memo } from "react";
import Col from "react-bootstrap/Col";

// The website logo image is a separate component
const LogoImage = ({xs, sm, lg, imageAdress, imageWidth, imageHeight}) => {
  return (
    <>
      <Col xs={xs} sm={sm} lg={lg} className="d-flex justify-content-start align-items-center">
        <img src={imageAdress} width={imageWidth} height={imageHeight} alt="website logo" />
      </Col>
    </>
  );
};

export default memo(LogoImage);
